export default __webpack_public_path__ + "static/media/Leaders_IMG-YMRaja.2e029909.png";